import Backdrop from '@mui/material/Backdrop';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';

export interface LoadingOverlayProps {
  label?: string;
  fullScreen?: boolean;
}

export function LoadingOverlay({ label = 'Loading…', fullScreen = true }: LoadingOverlayProps) {
  if (fullScreen) {
    return (
      <Backdrop open sx={{ color: 'primary.main', zIndex: (theme) => theme.zIndex.drawer + 1 }}>
        <Box display="flex" flexDirection="column" alignItems="center" gap={1.5}>
          <CircularProgress color="inherit" />
          <Typography variant="body2" color="inherit">
            {label}
          </Typography>
        </Box>
      </Backdrop>
    );
  }

  return (
    <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" gap={1.5} py={6}>
      <CircularProgress />
      <Typography variant="body2" color="text.secondary">
        {label}
      </Typography>
    </Box>
  );
}
